<template>
  <div class="flex flex-col">
    <!-- label for the input -->
    <label
      v-show="label"
      :for="`r-text-field-${_uid}`"
      class="text-sm font-semibold"
    >
      {{ label }}
    </label>

    <!-- input -->
    <input
      :id="`r-text-field-${_uid}`"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="onInputChange"
      :class="inputClasses"
    />

    <label
      v-show="validation && !isInputVaid"
      class="text-red-600 text-xs transition-all"
    >
      {{ $t(`errors.validate${capitalizeFirstLetter(validation)}`) }}
    </label>
  </div>
</template>

<script>
import {
  validateEmail,
  validateFirstName,
  validateLastName,
  toUpper
} from "../../../utils"

// Interval timeout
const INTERVAL_TIMEOUT = 1000

/**
 * Define the text field component
 */
export default {
  // set the component name
  name: "r-text-field",

  // local state
  data() {
    return {
      // flag on validation of the input
      isInputVaid: true,

      // typing timer
      timer: null
    }
  },

  // computed property
  computed: {
    inputClasses() {
      let classes = {
        "px-2": true,
        "py-1": true,
        border: true,
        rounded: true,
        "border-gray-400": true,
        "outline-none": true
      }

      if (this.isInputVaid) {
        classes = { ...classes, "focus:border-r-primary": true }
      } else {
        classes = {
          ...classes,
          "focus:border-red-600": !this.isInputVaid,
          "border-red-600": !this.isInputVaid
        }
      }

      return classes
    }
  },

  // external props
  props: {
    // the content of the label
    label: {
      type: String,
      default: ""
    },

    // the placeholder
    placeholder: {
      type: String,
      default: ""
    },

    // the value of the text field
    value: {
      type: String,
      default: ""
    },

    // the type of the input
    type: {
      type: String,
      default: "text"
    },

    // validation type on input
    validation: {
      type: String,
      default: ""
    }
  },

  // methods
  methods: {
    // on text input change
    onInputChange(event) {
      // extract value
      const { value } = event.target

      // set input
      this.$emit("input", value)

      if (this.validation) {
        this.validateInput(value)
      }
    },

    /**
     * Validate email input
     */
    validateInput(value) {
      this.timer = null
      this.timer = setTimeout(() => {
        this.isInputVaid = this.validate(value)
        if (value === "") this.isInputVaid = true
      }, INTERVAL_TIMEOUT)
    },

    /**
     * Validate
     */
    validate(value) {
      // validation
      switch (this.validation) {
        case "email":
          return validateEmail(value)
        case "firstName":
          return validateFirstName(value)
        case "lastName":
          return validateLastName(value)
        default:
          return true
      }
    },

    /**
     * capitalize First Letter
     */
    capitalizeFirstLetter(value) {
      return toUpper(value)
    },

    /**
     * On close
     */
    onCloseDialog() {
      this.isInputVaid = true
    }
  }
}
</script>
